<div class="flex-container">
  <mat-form-field appearance="outline" class="flex-item">
    <mat-label>{{ 'searchBar.searchBy' | transloco }}</mat-label>
    <mat-select [(ngModel)]="this.typeOfSearch" [placeholder]="'searchBar.selectAnOption' | transloco">
      @for (option of searchOptions; track option) {
        <mat-option [value]="option.value">
          {{ ('searchOptions.' + option.value) | transloco }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="flex-item-5 flex-container">
    <mat-label>{{ 'common.labels.search' | transloco }}</mat-label>
    <input matInput name="search" (keyup.enter)="performSearch()" [(ngModel)]="this.searchCriteria" [placeholder]="'common.labels.search' | transloco">
    <button
      matSuffix mat-raised-button
      (click)="performSearch()"
      color="accent"
      class="margin-sides-15"
      [attr.aria-label]="'searchBar.searchButton' | transloco"
      [disabled]="!this.searchCriteria">
      {{ 'common.labels.search' | transloco }}
    </button>
  </mat-form-field>
</div>